/* eslint-disable class-methods-use-this */
import axios from "axios";

import {
  API_ELASTICSEARCH_URL,
  API_PRICING_URL,
  API_SKU_URL,
  COMMON_HEADER_CONFIG
} from "../config";

class SkuService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListSkusByIds = (ids = "", isSearchAll) =>
    new Promise((resolve, reject) => {
      const data = {id: ids};
      let url = `${API_ELASTICSEARCH_URL}/list-sku/search`;
      if (isSearchAll === true) {
        url += "?size=100&page=1";
        data.item_available_ap = false;
      }
      const config = {
        method: "post",
        url,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListSkus = (params = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_SKU_URL}/skus`,
        params: {
          ...params,
          size: 900,
          page: 1
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  // JUST TEMPORARY
  getSkuById = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ELASTICSEARCH_URL}/sku/search?id=${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createSku = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_SKU_URL}/sku`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createMultiSku = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_SKU_URL}/sku/multi-create`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateSku = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_SKU_URL}/sku`,
        data,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  // updateSku = (data) => new Promise((resolve, reject) => {
  //   const config = {
  //     method: 'put',
  //     url: `${API_SKU_URL}/sku/${data.id}`,
  //     data,
  //     headers: {
  //     ...COMMON_HEADER_CONFIG,
  //       Authorization: `Bearer ${this.getAccessToken()}`
  //     },
  //   };
  //   axios(config)
  //     .then((response) => {
  //       if (response.data.data) {
  //         resolve(response.data.data);
  //       } else {
  //         reject(response);
  //       }
  //     })
  //     .catch((error) => {
  //       reject(error);
  //     });
  // });

  getPricingBySku = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_PRICING_URL}/pricings_by_object/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const skuService = new SkuService();

export default skuService;
